import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';

import { ResizeService } from '../services/resize.service';

@Component({
  selector: 'app-main-menu',
  templateUrl: './main-menu.component.html',
  styleUrls: ['./main-menu.component.scss']
})
export class MainMenuComponent implements OnInit, OnDestroy {

  @Input() logoUrl: string = '/assets/img/layout/logo.svg'
  @Input() isFooter: boolean = false
  private resizeSubscription: Subscription;
  public isMobile: boolean = false
  public isExpanded: boolean = false

  constructor(private resizeService: ResizeService) { }

  ngOnInit() {
    this.resizeSubscription = this.resizeService.onResize$
      .subscribe(({ innerWidth }) => this.checkMobile(innerWidth));
  }

  ngOnDestroy() {
    if (this.resizeSubscription) {
      this.resizeSubscription.unsubscribe();
    }
  }

  private checkMobile(windowWidth: Number): void {
    const query = windowWidth < 1024;

    if (this.isMobile && !query) {
      this.isExpanded = false;
    }
    this.isMobile = query ? true : false;
  }

  public toggle(): void {
    this.isExpanded = !this.isExpanded;
  }

  public close(event?): void {
    if (this.isExpanded && event.target.tagName === 'A') {
      this.isExpanded = false;
    }
  }

  public scrollIntoContact(): void {
    const contactElement = document.getElementById('contact');

    contactElement.scrollIntoView({ block: 'start', behavior: 'smooth' });
  }

  public goToSocial(url: string): void {
    window.open(url);
  }

  public scrollToTop(): void {
    window.scrollTo(0, 0);
  }

}
